<div class="container pt-5">
    <h1 class="fs-2 py-3">Email delivery troubleshooting</h1>

    <p>If you are having issues with the TeamMood emails, such as:</p>
    <ul>
        <li>No emails received</li>
        <li>Emails landing in spams or junks</li>
        <li>Links in emails not working</li>
    </ul>

    <p>Then please try our troubleshooting assistant by clicking below.</p>

    <button class="btn btn-primary mt-2" (click)="start()">Start Test</button>
</div>

